/** @format */
import React from "react";
function PLPFooter(props) {
  let { category = "" } = props;
  const footerHelpSection = (

    <div>

      <p style={{ fontWeight: "bold" }}>How can I become a verified buyer?</p>

      <p>

        You can sign up as a buyer on Qalara to start your buying journey. During the registration, we will ask you for basic information like organization name, nature of business, country of operation etc. This helps us safeguard your interests as well as the interests of our suppliers. We will reach out to you in case any additional information is required. If you are facing any issues with verification, write to us at{" "}

        <a href="mailto:help@qalara.com" className="qa-sm-color qa-underline">

          help@qalara.com

        </a>

      </p>

      <br></br>

    </div>

  );



  if (

    category === "Home Furnishing" ||

    category === "Home Furnishings" ||

    category === "home-furnishing"

  ) {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to sourcing wholesale home textiles on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What type of home furnishings are available on Qalara?

        </p>

        <p>

          At Qalara you can source a wide range of home linen and furnishings. We have an extensive selection of boho cushions and throws, table linen like placemats, chargers, napkins, tablecloths, farmhouse rugs or handmade rugs and more. Qalara sellers offer a wide range of styles and themes like modern, minimal, traditional, industrial, Scandinavian design, Christmas, holiday and mid-century modern. We have a fine selection of wholesale homewares and gifts across table linen, cushions and throws, and exotic floor coverings like hand knotted carpets and Persian wholesale carpets, waiting to be explored. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What are the different techniques used in manufacturing these

          products?

        </p>

        <p>

          Many of our bulk suppliers employ a mix of artisanal techniques like handweaving, kantha, patchwork, embroidery, applique, block-printing, tie-dye, aari work, batik, macrame, beadwork, screen printing, digital printing, and many other traditional and modern techniques to create unique designs.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What materials are used by Qalara’s suppliers?

        </p>

        <p>

          Our home furnishing sellers work with a variety of materials including cotton, jute, satin, silk and silk blends, wool and wool blends, recycled fabrics, upcycled textile waste, denim, different forms of grasses, and other natural fibres like banana fibre. Qalara has a wide range of cotton & jute ecofriendly rugs, jute cushions, cotton throws and more, perfect for modern homes.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Where are Qalara’s home furnishing suppliers from?

        </p>

        <p>

          Qalara simplifies global sourcing and wholesale by bringing together the best of home furnishing sellers from India and South East Asia. From handspun linen from South India to hand embroidered products from West India. Beautiful block printed furnishings from Rajasthan to delicately handwoven products from North East India. We even have a wide range of batik furnishings from Indonesia, tastefully handcrafted pieces from Cambodia and a wide range of merchandise from home furnishing sellers across Vietnam, Thailand, Sri Lanka and more.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What’s special about Qalara’s home furnishings?

        </p>

        <p>

          Qalara handpicks its home furnishings and homeware wholesale suppliers, making available the widest range of consciously designed home furnishings from across South Asia and South East Asia at competitive wholesale prices. Every product is a celebration of at least one of our brand values - Eco-friendly, artisanal, fair and social, organic, sustainable, recycled. Not only are these products unique and beautiful, they also exude high quality and fine craftsmanship. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Can I customize my home furnishings?

        </p>

        <p>

          Absolutely! Colours and sizes for most of our home furnishings can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What else should I consider before finalizing my order?

        </p>

        <p>

          A wide design range of products in a variety of materials can make the selection confusing. Here is a list of key pointers that can help you shortlist products of your choice:

          <br></br>

          <br></br>● Shortlist products using relevant filters - Category,

          Product Group, Product Type, Material etc

          <br></br>● Review our regularly updated trend-boards for ideas

          <br></br>● Go through product specifications and ‘how it’s made’

          description mentioned on the product page, especially sizing, care,

          and disclaimers

          <br></br>● You can also read up on the supplier to understand the

          brand philosophy. The content can help you market the products better

          <br></br>● Review the MOQs and the final landed price inclusive of

          freight and taxes

          <br></br>● Organize products into collections of your choice so that

          you can revisit them later

        </p>

        <br></br>



        {footerHelpSection}

      </div>

    );

  } else if (

    category === "Home Décor & Accessories" ||
    category === "Home Decor & Accessories" ||

    category === "home-decor-and-accessories"

  ) {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to sourcing wholesale home décor on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What home decor products are available on Qalara?

        </p>

        <p>

        You can browse through wholesale farmhouse decor and an array of categories like wall décor, tabletop decor, planters, votive candle holders, tealights, farmhouse photo frames, bells & chimes, vases, dreamcatchers, door handles, potpourri, dried flowers, ecofriendly candles, terracotta home accents, farmhouse pottery and many more unique artisanal products from wholesale home decor suppliers. Qalara sellers offer a wide range of decor styles and themes like modern, minimal, traditional, industrial, Scandinavian design, Christmas, holiday and mid-century modern. Buy bohemian home decor or wholesale farmhouse decor; Turkish home decor or quirky homeware, minimalist home decor or cottage décor, wholesale at Qalara.
        
        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What are the different techniques used in manufacturing these decor

          accents?

        </p>

        <p>

          Our bulk sellers use a mix of modern and popular local techniques to create unique products and designs. Some popular production methods are dhokra, woodcarving, jali cutting or lattice work, mosaic, metal casting, sand casting, hand painting, glasswork and inlay, amongst other traditional and modern techniques. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What materials are used in manufacturing these products?

        </p>

        <p>

          Our wholesale suppliers work with a wide range of materials including stone, ropes, fabrics, wood, leather, iron, copper, brass, aluminium, glass, marble, sabai grass, upcycled waste, jute and bamboo. Pick unique products like agate wall clocks or buy seagrass tabletop decoratives that are super trendy.  We even have moonj wall plates online and multipurpose storage boxes made using the popular kuana grass craft. Many of our home decor wholesalers recycle waste and upcycle scrap to create novel decor accents like recycled iron bells and chimes and coconut shell bowls.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Where are Qalara’s home decor suppliers from?

        </p>

        <p>

          Qalara simplifies global sourcing and wholesale by bringing together the best of home décor sellers from India & parts of South East Asia. From wooden classics from Saharanpur to brass and copper decoratives from Moradabad, beautiful marble products from Rajasthan to recycled dhokra from West Bengal and Orissa. Indulge is a comprehensive range of home decor from sellers across India, Vietnam, Indonesia, Thailand, Cambodia and more.  Take your pick from brass suppliers from Moradabad to marble decor suppliers from North India; basket wholesalers from Indonesia to copper bells suppliers from Kutch.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What’s special about Qalara’s home decor?

        </p>

        <p>

          Qalara handpicks its wholesale home decor suppliers, making available the widest range of consciously designed decor from across India and South East Asia at competitive wholesale prices. Every product is a celebration of at least one of our brand values - Eco-friendly, artisanal, fair and social, organic, sustainable, recycled. Not only are these products unique and beautiful, they also exude high quality and fine craftsmanship. You can now source from India, without compromising on quality, craftsmanship or selection.  
        
        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>Can I customize my home decor?</p>

        <p>

          Absolutely! Colours and sizes for most decor products can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What else should I consider before finalizing my order?

        </p>

        <p>

          A wide design range of products in a variety of materials can make the

          selection confusing. Here is a list of key pointers that can help you

          shortlist products of your choice:

          <br></br>

          <br></br>● Shortlist products using relevant filters - Category,

          Product Group, Product Type, Material etc

          <br></br>● Review our regularly updated trend-boards for ideas

          <br></br>● Go through product specifications and ‘how it’s made’

          description mentioned on the product page, especially sizing, care,

          and disclaimers

          <br></br>● You can also read up on the supplier to understand the

          brand philosophy. The content can help you market the products better

          <br></br>● Review the MOQs and the final landed price inclusive of

          freight and taxes<br></br>● Organize products into collections of your

          choice so that you can revisit them later

        </p>

        <br></br>

        {footerHelpSection}

      </div>

    );

  } else if (

    category === "Kitchen & Dining" ||

    category === "kitchen-and-dining"

  ) {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to sourcing wholesale kitchen & dining on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What kitchenware, cookware and dining products are available on

          Qalara?

        </p>

        <p>

          You can choose from a range of wholesale kitchen products like platters, handmade cutting boards or cheese boards, utensils, crockery, serving dishes, glasses, wholesale cutlery, bar accessories, coasters, handmade coffee mugs or handmade ceramic mugs, ecofriendly water bottles, custom pasta bowls or handmade wooden bowls, enamel wood salad bowls, kitchen storage and traditional indigenous kitchen essentials like masai coffee filter and cups, mortar & pestle wholesale buys and more. Qalara sellers offer a wide range of styles and themes like modern, minimal, traditional, industrial, Scandinavian design, Christmas, holiday and mid-century modern.
        
        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What different techniques are employed in manufacturing Kitchen and

          Dining products?

        </p>

        <p>

          Many of our kitchen linen suppliers and kitchen accessories wholesalers employ a mix of craft techniques to create unique products and designs. Some popular production methods are hand carving, hammering, metal cladding, inlay, hand painting and polishing and pottery, rendering beautiful products like handmade iron bowls, silver thalis, copper bottles and more.  

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What materials are used in manufacturing these products?

        </p>

        <p>

          Our curated wholesale kitchen and serveware suppliers work with a wide range of materials including stone, wood, iron, brass, copper, aluminium, glass, marble, natural fibres, sabai grass, clay, terracotta, and many other indigenous materials.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Where are Qalara’s kitchen and dining suppliers from?

        </p>

        <p>

          Qalara simplifies global sourcing and wholesale by bringing together the best of kitchen & dining sellers from India & parts of South East Asia. From wooden cheese boards from Saharanpur to copper utensils and drinkware from Moradabad, beautiful clay drinkware from Longpi in North East India to stunning marble coasters from Rajasthan, hand-painted serveware from Kashmir to handwoven grass table essentials from Indonesia, there is something for everyone. Indulge is a comprehensive range of kitchen and dining products from sellers across India, Vietnam, Indonesia, Thailand, Cambodia and more. Pick from hand painted coaster suppliers from Kashmir to copper cutlery suppliers from Moradabad; coconut shell bowl wholesale suppliers from Sri Lanka to wooden tray suppliers from Indonesia.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What’s special about Qalara’s kitchen and dining products?

        </p>

        <p>

          Qalara handpicks its wholesale kitchen suppliers and serveware wholesalers, making available the widest range of consciously designed kitchenware from across South Asia and South East Asia at competitive wholesale prices. Every product is a celebration of at least one of our brand values - Eco-friendly, artisanal, fair and social, organic, sustainable, recycled. Not only are these products unique and beautiful, they also exude high quality and fine craftsmanship. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Can I customize my kitchen and dining products?

        </p>

        <p>

          Absolutely! Colours and sizes for most kitchen and dining products can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What else should I consider before finalizing my order?

        </p>

        <p>

          A wide design range of products in a variety of materials can make the

          selection confusing. Here is a list of key pointers that can help you

          shortlist products of your choice:

          <br></br>

          <br></br>● Shortlist products using relevant filters - Category,

          Product Group, Product Type, Material etc

          <br></br>● Review our regularly updated trend-boards for ideas

          <br></br>● Go through product specifications and ‘how it’s made’

          description mentioned on the product page, especially sizing, care,

          and disclaimers<br></br>● You can also read up on the supplier to

          understand the brand philosophy. The content can help you market the

          products better

          <br></br>● Review the MOQs and the final landed price inclusive of

          freight and taxes

          <br></br>● Organize products into collections of your choice so that

          you can revisit them later

        </p>

        <br></br>

        {footerHelpSection}

      </div>

    );

  } else if (category === "Fashion" || category === "fashion") {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to sourcing wholesale fashion & accessories on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What types of fashion & accessories are available on Qalara?

        </p>

        <p>

          Qalara hosts a huge collection of fashion accessories and textiles, created using different materials, art forms and production methods. You can choose from handmade bags, vanity pouches, ecofriendly backpacks, clutches, wallets, belts, sustainable and handmade clothing like shirts, pants, skirts, dresses and more.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What manufacturing techniques are employed in making these products?

        </p>

        <p>

          Many of our wholesale fashion suppliers and fabrics manufacturers use a mix of modern and traditional techniques to create unique products and designs. They employ a variety of ingenious production methods like phulkari, chikankari, hand painting, batik, shibori, tie-dye, ikat, aari work, extra weft weaving, hand block printing, handweaving, applique, kantha, patch-work and numerous other surface embellishment and weaving techniques.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What materials are used in fashion and accessories

          manufacturing?

        </p>

        <p>

          Our wholesale fashion suppliers work with a variety of fabrics like organic cotton, eri silk, tussar, muga, pashmina wool, jute, linen and different ready textiles like chanderi cotton, satin, wool and wool blends. Accessories suppliers also use leather and denim along with other surface embellishments.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          Where are Qalara’s fashion suppliers from?

        </p>

        <p>

          Qalara simplifies global sourcing and wholesale by bringing together the best of fashion and accessories sellers from India & South East Asia. From handspun and handwoven apparel from South India and North East India to fine leather bags and belts from Kutch; there is something for everyone. Indulge is a comprehensive range of fashion and accessories from sellers across India, Vietnam, Indonesia, Thailand, Cambodia and more.  Take your pick from organic fabric wholesale suppliers, block printed fabrics suppliers, bamboo fabric wholesalers, handspun fabric suppliers, mulberry silk fabric suppliers, handwoven fabric suppliers, cotton fabric suppliers, silk suppliers and more available on Qalara, a global wholesale market. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What’s special about Qalara’s fashion and accessories ?

        </p>

        <p>

          Qalara handpicks its wholesale fashion suppliers, making available the widest range of consciously designed apparel and accessories from across South Asia and South East Asia at competitive wholesale prices. Every product is a celebration of at least one of our brand values - Eco-friendly, artisanal, fair and social, organic, sustainable, recycled. Not only are these products unique and beautiful, they also exude high quality and fine craftsmanship. Indulge in a fine mix of classic and trendy styles at our wholesale fashion store.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Can I customize my fashion and accessories?

        </p>

        <p>

          Absolutely! Colours and sizes for most products can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What else should I consider before finalizing my order?

        </p>

        <p>

          A wide design range of products in a variety of materials can make the

          selection confusing. Here is a list of key pointers that can help you

          shortlist products of your choice:

          <br></br>

          <br></br> ● Shortlist products using relevant filters - Category,

          Product Group, Product Type, Material etc<br></br>● Review our

          regularly updated trend-boards for ideas<br></br>● Go through product

          specifications and ‘how it’s made’ description mentioned on the

          product page, especially sizing, care, and disclaimers

          <br></br>● You can also read up on the supplier to understand the

          brand philosophy. The content can help you market the products better

          <br></br>● Review the MOQs and the final landed price inclusive of

          freight and taxes<br></br>● Organize products into collections of your

          choice so that you can revisit them later

        </p>

        <br></br>

        {footerHelpSection}

      </div>

    );

  } else if (category === "Baby & Kids" || category === "baby-and-kids") {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to sourcing wholesale kids toys & games on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What baby and kids products are available on Qalara?

        </p>

        <p>

          At Qalara you can choose from a collection of baby and kids toys. We also have age-specific games and toys that help in your child’s development, enhancing motor skills, hand-eye coordination, social skills, cognitive skills, problem solving and a lot more.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What are the different techniques used to manufacture these products?

        </p>

        <p>

          Many of our kids wholesale vendors are renowned for their unique handmade wholesale products. They employ a variety of production methods like lacquer work, hand painting, hand printing and carving to create iconic toys for little ones.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What materials are used in manufacturing these products?

        </p>

        <p>

          Our kids wholesale vendors work with a variety of safe and child-friendly materials like sustainable wood to create classic toys. 

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>Where are Qalara’s suppliers from?</p>

        <p>

          Qalara simplifies global sourcing and wholesale by bringing together the best of toy suppliers from India & parts of South East Asia. Indulge is a comprehensive range of child-friendly toys from sellers across Saharanpur, Jaipur, Narsapur, even Srinagar, at our wholesale kids shop on Qalara.  

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What’s special about Qalara’s baby and kids products?

        </p>

        <p>

          Qalara handpicks its wholesale kids product vendors, making available the widest range of consciously designed wholesale toys at competitive wholesale prices. Every product is a celebration of at least one of our brand values - Eco-friendly, artisanal, fair and social, organic, sustainable, recycled. Not only are these products unique and beautiful, they also exude high quality and fine craftsmanship. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Can I customize my baby and kids products?

        </p>

        <p>

          Absolutely! Colours and sizes for most baby and kids products can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What else should I consider before finalizing my order?

        </p>

        <p>

          A wide design range of products in a variety of materials can make the

          selection confusing. Here is a list of key pointers that can help you

          shortlist products of your choice:

          <br></br>

          <br></br>● Shortlist products using relevant filters - Category,

          Product Group, Product Type, Material etc

          <br></br>● Review our regularly updated trend-boards for ideas

          <br></br>● Go through product specifications and ‘how it’s made’

          description mentioned on the product page, especially sizing, care,

          and disclaimers<br></br>● You can also read up on the supplier to

          understand the brand philosophy. The content can help you market the

          products better<br></br>● Review the MOQs and the final landed price

          inclusive of freight and taxes<br></br>● Organize products into

          collections of your choice so that you can revisit them later

        </p>

        <br></br>

        {footerHelpSection}

      </div>

    );

  }
   else if (category === "Jewelry" || category === "jewelry") {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to sourcing wholesale jewelry on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What type of jewelry is available on Qalara?

        </p>

        <p>

          At Qalara you can choose products from a collection of women’s jewelry like necklaces, bracelets, handmade earrings and more.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What are the different techniques used to manufacture jewelry on

          Qalara?

        </p>

        <p>

          Qalara brings together some of the best jewelry manufacturers from around Asia. Many of our wholesale jewelry suppliers are renowned for their unique handcrafted products. They employ a variety of centuries-old techniques of hammering, inlay work, gem craft, wire braiding, beading, dhokra, kundan work and meenakari amongst many others.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What materials are used to manufacture jewelry on Qalara?

        </p>

        <p>

          Our top jewelry manufacturers work with gold, sterling silver, copper, brass and other skin-friendly metals. Qalara also has a wide range of precious and semi-precious gemstone jewelry featuring topaz, amethyst, ruby, sapphire, aquamarine, citrine, garnet, jade, onyx, and more from jewellery manufacturers. You will also find unique jewelry made from upcycled fabrics, glass and natural fibers.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          Where are Qalara’s jewelry suppliers from?

        </p>

        <p>

          Qalara simplifies global sourcing and wholesale by bringing together the best of jewelry sellers from India & parts of South East Asia. Indulge is a comprehensive range of skin-friendly precious and semi-precious fine jewelry from sellers across India, Vietnam, Indonesia, Thailand, Cambodia and more. We have wholesale copper jewelry suppliers from Moradabad; gemstone jewelry wholesale from Thailand and Rajasthan to sterling silver jewelry suppliers from Cuttack and parts of North India.  

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What’s special about Qalara’s jewelry range?

        </p>

        <p>

         Qalara handpicks its fashion jewellery wholesalers, making available the widest range of consciously designed jewelry from India at competitive wholesale prices. Every product is a celebration of at least one of our brand values - Eco-friendly, artisanal, fair and social, organic, sustainable, recycled. Not only are these products unique and beautiful, they also exude high quality and fine craftsmanship. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>Can I customize my jewelry?</p>

        <p>

          Absolutely! Metal, stone and size for most jewelry products can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What else should I consider before finalizing my order?

        </p>

        <p>

          A wide design range of products in a variety of materials can make the

          selection confusing. Here is a list of key pointers that can help you

          shortlist products of your choice:

          <br></br>

          <br></br>● Shortlist products using relevant filters - Category,

          Product Group, Product Type, Material etc

          <br></br>● Review our regularly updated trend-boards for ideas

          <br></br>● Go through product specifications and ‘how it’s made’

          description mentioned on the product page, especially sizing, care,

          and disclaimers

          <br></br>● You can also read up on the supplier to understand the

          brand philosophy. The content can help you market the products better

          <br></br>● Review the MOQs and the final landed price inclusive of

          freight and taxes <br></br>● Organize products into collections of

          your choice so that you can revisit them later

        </p>

        <br></br>



        {footerHelpSection}

      </div>

    );

  } else if (

    category === "Stationery & Novelty" ||

    category === "stationery-and-novelty"

  ) {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to sourcing wholesale stationery on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What type of stationery & novelty products are available on Qalara?

        </p>

        <p>

        At Qalara you can choose from a collection of ecofriendly notebooks, journals, diaries and planners. Buy the best of handmade stationery wholesale at Qalara.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What are the different techniques used to manufacture stationery &

          novelty products on Qalara?

        </p>

        <p>

          Many of our wholesale suppliers are renowned for their unique handcrafted products. They employ a variety of centuries-old techniques, like handmade paper crafts, hand binding, leather crafts, papier mache, among others.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What materials are used to manufacture stationery and novelty products

          on Qalara?

        </p>

        <p>

          Our bulk stationery and novelty sellers work with handmade paper, textiles, leather and many other indigenous materials to create a unique range of high-quality products.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          Where are Qalara’s stationery and novelty suppliers from?

        </p>

        <p>

          Qalara simplifies global sourcing and wholesale by bringing together the best of stationery sellers from India & parts of South East Asia. Indulge is a comprehensive range of stationery from sellers across India, Vietnam, Indonesia, Thailand, Cambodia and more.          </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          What’s special about Qalara’s stationery and novelty range?

        </p>

        <p>

          Qalara handpicks its wholesale suppliers, making available the widest range of consciously designed stationery and novelty products from India at competitive wholesale prices. Every product is a celebration of at least one of our brand values - Eco-friendly, artisanal, fair and social, organic, sustainable, recycled. Not only are these products unique and beautiful, they also exude high quality and fine craftsmanship. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          Can I customize my stationery and novelty products?

        </p>

        <p>

          Absolutely! Color and size for most products can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What else should I consider before finalizing my order?

        </p>

        <p>

          A wide design range of products in a variety of materials can make the

          selection confusing. Here is a list of key pointers that can help you

          shortlist products of your choice:

          <br></br>

          <br></br>● Shortlist products using relevant filters - Category,

          Product Group, Product Type, Material etc<br></br>● Review our

          regularly updated trend-boards for ideas<br></br>● Go through product

          specifications and ‘how it’s made’ description mentioned on the

          product page, especially sizing, care, and disclaimers

          <br></br>● You can also read up on the supplier to understand the

          brand philosophy. The content can help you market the products better

          <br></br>● Review the MOQs and the final landed price inclusive of

          freight and taxes<br></br>● Organize products into collections of your

          choice so that you can revisit them later

        </p>

        <br></br>



        {footerHelpSection}

      </div>

    );

  } else {

    return (

      <div className="seo-slp-footer">

        <h3 className="qa-fw-b">A buyer’s guide to global sourcing & wholesale on Qalara</h3>

        <br></br>

        <p style={{ fontWeight: "bold" }}>

          What types of products are available on Qalara?

        </p>

        <p>

          Qalara is a digital platform for all sourcing and wholesale needs. It brings you the best of artisanal, eco-friendly, organic, recycled, fair & social products, made by responsible producers from India, South East Asia and nearby regions. You can source or buy wholesale home decor, home linen, kitchen & dining ware, fashion accessories, rugs, jewellery, baby products and more on Qalara. The sellers on this platform offer a wide range of styles like modern, minimal, traditional, industrial, Scandinavian design, Christmas, holiday and mid-century modern. Our sellers specialize in techniques like kalamkari hand painting, ikat weaving, numerous ingenious handloom crafts, marble inlay, block printing, resist dyeing, hand embroidery, basketry, hand carving, crochet, macrame and many more. 

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>Can you customize products?</p>

        <p>

          Absolutely! Color and size for most products can be customized. We can also add your label, branding and designs as per your requirements. In case you already have a design, please send us a picture and we will get back to you with detailed specs, post a discussion with the supplier. Qalara sellers may however have specific MOQ requirements for customization.

        </p>

        <br></br>



        <p style={{ fontWeight: "bold" }}>

          How do we know that goods are of the right quality and will be

          produced on time?

        </p>

        <p>

          We map Indian crafts to design and develop high quality, on-trend products. We also quality inspect all orders, monitor production for custom orders, facilitate documentation and secure payments, offer the best freight costs and ensure safe door delivery. 

          <br></br>

          <br></br>

          For custom orders, we monitor the production of your order and share updates through the key milestones of the production process. We also facilitate inline and final line inspections for large custom orders - which can be done remotely via video meetings. We conduct a final Quality Inspection once goods are ready and review all documentation. We can also facilitate quality testing as per your requirements from a certified lab at an additional fee. These quality standards need to be provided at the time of placing the order and are recommended for larger orders.

          <br></br>

          <br></br>Once products are ready and have been inspected, a trusted logistics partner associated with Qalara ships the products, either by Air or Ocean Freight as decided at the time of placing the order. We keep a constant track of your order till the order is delivered to you at the designated location, ensuring reliable service from order confirmation to delivery.

        </p>

        <br></br>



        {footerHelpSection}

      </div>

    );

  }

}

export default PLPFooter;